import React from "react"
import "./UserAvatar.css"

function CollegeAvatar(props) {
  return (
    <div
      className={"user-avatar-box college-user-avatar"}
    >
      <div className="avatar-wrapper">
        <img
          src={props.icon || "../../assets/img/avatar.png"}
          className="user-avatar-img"
          alt="user's avatar"
        />
      </div>
      {props.children}
    </div>
  )
}

export default CollegeAvatar
